import React from 'react';
import { BreadcrumbList } from 'schema-dts';

import { usePathname } from 'src/hooks/router-hooks';
import { useDeps } from 'src/hooks/useDeps';
import { Breadcrumb } from 'src/components/Breadcrumbs/breadcrumb.utils';

import { Schema } from '../Schema/Schema';

type BreadcrumbSchemaProps = {
    breadcrumbs: Breadcrumb[];
    current: string;
};

export const BreadcrumbSchema = React.memo(function BreadcrumbSchema(props: BreadcrumbSchemaProps) {
    const { breadcrumbs, current } = props;
    const pathname = usePathname();
    const { DOMAIN } = useDeps().env;
    const items = breadcrumbs.map((breadcrumb, index) => {
        const url_key = breadcrumb.url_key.replace(/^\//, '');
        const url = `/` + breadcrumb.url_path.concat(url_key).join('/');
        return {
            '@type': 'ListItem',
            position: index + 2,
            name: breadcrumb.name,
            item: `https://${DOMAIN}${url}`,
        };
    });
    items.unshift({
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `https://${DOMAIN!}`,
    });
    items.push({
        '@type': 'ListItem',
        position: breadcrumbs.length + 2,
        name: current,
        item: `https://${DOMAIN}${pathname}`,
    });
    return (
        <Schema
            input={
                {
                    '@context': 'http://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: items,
                } as BreadcrumbList
            }
        />
    );
});
